import { useStepStartedFocusAnalytics } from 'features/application/hooks/useStepStartedFocusAnalytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import {
  ANDROID_APP_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
} from 'shared/constants/appStore';
import { isIOSBrowser, isWebMac } from 'shared/constants/platform';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const DownloadMobileAppSuccessScreen = () => {
  useViewDidFocusScreenAnalyticsEvent({
    key: 'mobileAppDownLoad',
  });

  useStepStartedFocusAnalytics({
    analyticsId: 'mobileAppDownLoad',
  });

  const { t: translatedText } = useTranslation('signup', {
    keyPrefix: 'approved',
  });

  const handleDownloadButtonAction = () => {
    if (isWebMac || isIOSBrowser) {
      window.open(IOS_APP_STORE_URL, '_blank');
    } else {
      window.open(ANDROID_APP_PLAY_STORE_URL, '_blank');
    }
  };
  return (
    <SuccessScreen
      primaryButton={{
        label: translatedText('successScreen.button'),
        onPress: () => {
          handleDownloadButtonAction();
        },
        analyticsId: 'downloadAppButtonClicked',
      }}
      visual="DISCOBALL_A"
      eyebrowText={translatedText('successScreen.congrats')}
      titleText={translatedText('successScreen.title')}
      content={
        <>
          <BodyBaseText style={styles.contentText}>
            {translatedText('successScreen.description')}
          </BodyBaseText>
          <View style={styles.listItemContainer}>
            <ListItem
              primaryCopy={translatedText('successScreen.listItems.fees')}
              leadingAccessory={{
                id: 'apyIcon',
                name: VXLComponentId.ICON,
                props: {
                  iconKey: 'NO_FEES',
                },
              }}
              showsChevron={false}
            />
            <View style={styles.dividerContainer}>
              <HairLineDivider />
            </View>
            <ListItem
              primaryCopy={translatedText('successScreen.listItems.payDay')}
              leadingAccessory={{
                id: 'apyIcon',
                name: VXLComponentId.ICON,
                props: {
                  iconKey: 'CALENDAR',
                },
              }}
              showsChevron={false}
            />
            <View style={styles.dividerContainer}>
              <HairLineDivider />
            </View>
            <ListItem
              primaryCopy={translatedText('successScreen.listItems.borrow')}
              leadingAccessory={{
                id: 'apyIcon',
                name: VXLComponentId.ICON,
                props: {
                  iconKey: 'DEPOSIT_CASH',
                },
              }}
              showsChevron={false}
            />
          </View>
        </>
      }
    />
  );
};

const styles = StyleSheet.create({
  contentText: {
    textAlign: 'center',
  },
  dividerContainer: {
    marginHorizontal: theme.spacing.m,
  },
  listItemContainer: {
    paddingTop: theme.spacing.m,
  },
});
export default DownloadMobileAppSuccessScreen;
